/**
     * @desc 设备上报外设状态
可能产生业务错误码：510001、510002、511001
     */

import * as SWR from 'swr';

import * as defs from '../../baseClass';
import * as Hooks from '../../../hooks';
import { PontCore } from '../../../pontCore';

export class Params {}

export const method = 'POST';

export function mutate(
  params = {},
  newValue = undefined,
  shouldRevalidate = true,
) {
  return SWR.mutate(
    Hooks.getUrlKey('/api/bs-vmeeting/v3/member/peripheral', params, 'POST'),
    newValue,
    shouldRevalidate,
  );
}

export function useDeprecatedRequest(params = {}, swrOptions = {}) {
  return Hooks.useRequest(
    '/api/bs-vmeeting/v3/member/peripheral',
    params,
    swrOptions,
    { method: 'POST' },
  );
}

export function request(
  params: Params,
  body: defs.client.ReportExternalStatusParametersOnEquipment,
  options?: any,
) {
  return PontCore.fetch(
    PontCore.getUrl('/api/bs-vmeeting/v3/member/peripheral', params, 'POST'),
    {
      method: 'POST',

      body,
      ...options,
    },
  );
}
